/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class UiEmptyCollectionComponent extends Component {
  @service router;

  @action
  handleClick() {
    if (this.args.route) {
      this.router.transitionTo(this.args.route);
    }
  }
}
